module.exports = __webpack_public_path__ + "static/media/pls.abd82295.png";